var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Sms.SendCode",
    "options": {
        "objc_class_prefix": "SmsSendCode",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Request",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "mobilePhone",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "deviceId",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "signature",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "module",
                    "id": 4
                }
            ]
        }
    ]
}).build();

export default _root;


// WEBPACK FOOTER //
// ./js/mall/withdraw/smscode.pb.js